import { render, staticRenderFns } from "./_OrganizationModalForm.vue?vue&type=template&id=40fbdf24&scoped=true&"
import script from "./_OrganizationModalForm.vue?vue&type=script&lang=js&"
export * from "./_OrganizationModalForm.vue?vue&type=script&lang=js&"
import style0 from "./_OrganizationModalForm.vue?vue&type=style&index=0&id=40fbdf24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fbdf24",
  null
  
)

export default component.exports